import _ from "lodash";
import React from "react";
import { useLazyGetPendingBusinessSheetGroupingsQuery } from "../../../services/recommendations/businessSheetEndpoints";

export const PendingBusinessSheetGroupingContext = React.createContext(null);

export const usePendingBusinessSheetGroupingData = () => React.useContext(PendingBusinessSheetGroupingContext)

export const PendingBusinessSheetGroupingProvider = ({ children, filter = null, isReady = false }) => {
    const [load, { data, error, isLoading, isFetching }] = useLazyGetPendingBusinessSheetGroupingsQuery();
    const { groupings, total } = data || { groupings: [], total: 0 };

    const reload = () => {
        if (!isReady || !filter || _.isEmpty(filter)) {
            return;
        }
        load({ ...filter }).unwrap();
    };

    React.useEffect(reload, [ filter, isReady ]);

    return (
        <PendingBusinessSheetGroupingContext.Provider value={{ 
            data: groupings, 
            error, 
            isLoading, 
            isFetching, 
            total: total
        }}>
            {children}
        </PendingBusinessSheetGroupingContext.Provider>
    )
}